// Preloader.js
import React from 'react';
// import './Preloader.css'; // Add styling for the preloader here

const Preloader = () => {
  return (
    <div className="preloader">
  <div className="loading">
    <div></div>
    <div></div>
  </div>
</div>
  
  );
};

export default Preloader;
